import React from 'react';
import { useTranslation } from 'react-i18next';

const PageTitle = () => {
  const { t: translate } = useTranslation();
  return (
    <h1 className="m-0 text-f3">
      <b>{translate('settings_page_title')}</b>
    </h1>
  );
};

export default PageTitle;
